import { render, staticRenderFns } from "./UITimeStepper.vue?vue&type=template&id=21e2e652&scoped=true"
import script from "./UITimeStepper.vue?vue&type=script&lang=js"
export * from "./UITimeStepper.vue?vue&type=script&lang=js"
import style0 from "./UITimeStepper.vue?vue&type=style&index=0&id=21e2e652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2e652",
  null
  
)

export default component.exports